import React,{useState} from 'react';
import {css} from 'emotion';
import history from '../../../../../utils/history'

const ItemMenu = (props) =>{

  const [hover,setHover] = useState(false);
  const goToPage = () =>{
      if(props.text == 'Accueil')
      history.push({pathname:'/'})
      else if(props.text == 'Profil')
      history.push({pathname:'/profil'})
      else if(props.text == 'Formulaires')
      history.push({pathname:'/liste-formulaire'})
      else if(props.text == "Déclarations")
      history.push({pathname:'/vos-déclarations'})
      else
      history.push({pathname:'/'})
  }
  return(
    <div onClick={goToPage} onMouseEnter={()=>{setHover(true)}} onMouseLeave={()=>{setHover(false)}} className={css`cursor:pointer;background-color:${(hover || props.pathname.includes(props.location.pathname)) ?'#0085C6':'white'};flex:1;border-bottom:1px solid #e8e8e8;display:flex;flex-direction:column;align-items:center;justify-content:center`}>
        {
          React.Children.map(props.children, (child,prop) => {
            return React.cloneElement(child,{color:(hover ||props.pathname.includes(props.location.pathname))?'white':'#0085C6'});
    })}
    <div className={css`font-size:10px;margin-top:10px;color:${(hover ||props.pathname.includes(props.location.pathname))?'white':'#0085C6'}`}>{props.text}</div>
    </div>
  )
}

export default ItemMenu;
